import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { isMobile, isTablet } from 'react-device-detect';

let device = '';

const getMaxBatchInterval = () => {
  return process.env.MAX_BATCH_INTERVAL ? process.env.MAX_BATCH_INTERVAL : 15000;
};

const getConnectionString = () => {
  const connectionString = process.env.GATSBY_CONNECTION_STRING || 'InstrumentationKey=f6723075-9ec9-42f8-865e-f40d3ecc67b3;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=0a26069f-7354-4b6f-84a9-7dc7c356370b';
  if (connectionString.startsWith('#{') && connectionString.endsWith('}')) {
    return undefined;
  }
  return connectionString;
};

const createAppInsightsService = () => {
  const connectionString = getConnectionString();
  if (!connectionString) {
    return null;
  }

  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      disableAjaxTracking: true,
      maxBatchInterval: getMaxBatchInterval(),
    },
  });


 return appInsights;
};

const appInsightsService = createAppInsightsService();

export const trackEvent = async (name, extraInfo = {}) => {
  if (!appInsightsService) return;
  const formattedName = `pulsecard.co.uk: ${name}`;
  appInsightsService.trackEvent({
    name: formattedName,
    properties: { origin: window.location.pathname, device, ...extraInfo },
  });
};

export const trackPageView = async (pageName, extraInfo) => {
  if (!appInsightsService) return;
  const formattedName = `pulse.co.uk: ${pageName} view`;
  appInsightsService.trackPageView({
    name: formattedName,
    properties: { device, ...extraInfo },
  });
};

export const setDevice = () => {
  switch (true) {
    case isMobile:
      device = 'mobile';
      break;
    case isTablet:
      device = 'tablet';
      break;
    default:
      device = 'desktop';
  }
};

export default appInsightsService;